module.exports = __webpack_public_path__ + "static/img/10.8c5d7e5d.png";